import {pickProperty} from '../../../../core/graphql/graphql-utils'
import {JobRequestDetail_GetAgencyGql} from '../../../../../__generated__/types'
import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {Observable, of} from 'rxjs'
import {catchError, map} from 'rxjs/operators'

export type AgencyResolved =
  | {
      jobRequestCode?: string
      logo?: {
        title?: string
        url: string
      }
    }
  | undefined

@Injectable({providedIn: 'root'})
export class JobRequestAgencyResolver {
  constructor(private getAgencyGql: JobRequestDetail_GetAgencyGql) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AgencyResolved> {
    const slug = route.parent?.paramMap.get('agencySlug')
    if (!slug) {
      return of(undefined)
    }

    return this.getAgencyGql.fetch({slug}).pipe(
      map(res => {
        const agency = pickProperty(res.data, 'agencyBySlug')
        if (!agency) return

        const {jobRequestCode, logo} = agency

        return {
          jobRequestCode,
          logo,
        }
      }),
      catchError(e => {
        console.error(e)
        return of(undefined)
      }),
    )
  }
}
